var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.riskStatement},[_c('div',{class:_vm.$style.slogan}),_vm._v(" "),_c('div',{class:_vm.$style.statement},[_vm._v("\n    贷款有风险 借款需谨慎 请根据个人能力合理贷款 理性消费避免逾期\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }